import fizapilib, { type JsonFw } from "./fizapilib.auto.ts";
import FizConfig from "../FizConfig.ts";
import { getAuthorization } from "./Authorization.ts";

const API = FizConfig.API_BASE_URL+"api";

type ProgressBar = {progress: (rate: number) => void, close: () => void}

type Call = [name:string, data: {[x:string]:any}, resolve :(value: any) => void, reject :(reason?: any) => void]

function a0i(i :number){
  if(i<0) throw new Error("Invalid call a"+i)
  if(i===0) return '';
  if(i<10) return 'a0'+i
  if(i<100) return 'a'+i
  throw new Error("Invalid call a"+i)
}

// No-op progress bar
const noopProgressBar : ProgressBar = {
  progress: () => {},
  close: () => {}
}

var
  callContext  = {
    uploadProgressBar:noopProgressBar,
    calls:[] as Call[],
    groupingTimeout:undefined,
  };

  
function add(call :Call){
  callContext.calls.push(call)
  clearTimeout(callContext.groupingTimeout)
  callContext.groupingTimeout = setTimeout(execute,20)
}
function execute(){
  const
    post = new FormData(),
    headers = {
      Authorization : getAuthorization()
    },
    calls = callContext.calls,
    uploadProgressBar = callContext.uploadProgressBar;

  //reinit context  
  callContext = {
    uploadProgressBar:noopProgressBar,
    calls:[] as Call[],
    groupingTimeout:undefined
  };

  calls.forEach(([name,data,resolve,reject],index)=>{
    const a0x = a0i(index);
    if(index!==0){
      post.append(a0x+"call", name)
    }
    Object.entries(data).forEach(([key,value])=>{
      if(value!==undefined && value !==null){
        // Handle File and Blob objects
        if(value instanceof File || value instanceof Blob){
          post.append(a0x+key, value)
        }else{
          post.append(a0x+key, value.toString())
        }
      }
    })
  })

  
  const xhr = new XMLHttpRequest();
  uploadProgressBar.progress(0);

  // Track upload progress
  xhr.upload.addEventListener('progress', (event) => {
    if (event.lengthComputable) {
      const percent = event.loaded / event.total;
      uploadProgressBar.progress(percent * 0.99);
    }
  });

  xhr.addEventListener('load', () => {
    uploadProgressBar.close();
    if (xhr.status >= 200 && xhr.status < 300) {
      
      const json = JSON.parse(xhr.responseText);
      handleResponses(json, calls);
      
    } else {
      calls.forEach(call=>call[3](new Error(`HTTP ${xhr.status}: ${xhr.statusText}`)));
    }
  });

  xhr.addEventListener('error', () => {
    uploadProgressBar.close();
    calls.forEach(call=>call[3](new Error(`HTTP ${xhr.status}: ${xhr.statusText}`)));
  });

  xhr.open('POST', API+'/'+calls[0][0]);
  xhr.withCredentials = true;
  for(var name in headers){
    xhr.setRequestHeader(name, headers[name]);
  }
  xhr.send(post);
  
}


function handleResponses(json: any, calls: Call[]){
  const errors = [];
  //WARNING without this sorting a00 ... a0x are shuffled, it is weird but...
  const entries = Object.entries(json).sort((en1,en2)=>en1[0].localeCompare(en2[0])) 
  entries.forEach(([key,value],index)=>{
    var [name,data,resolve,reject] = calls[index];
    try{
      resolve(value)
    }catch(e){
      try{
        reject(e)
      }catch(errorAfterHandling){
        errors.push(errorAfterHandling)
      }
    }
  })
  if(errors.length===1) throw errors[0]
  if(errors.length>1){
    throw Object.assign(new Error(errors.map(e=>e.message).join()),{stack:errors.map(e=>e.stack).join('\n')});
  }
}

function flattenobject(prefix :string,src :JsonFw[]|JsonFw|string[]|string|File|Blob|Date,target : {[x:string]:any}){
  if(src===null || src===undefined){
    //nothing to do
  }else if(src instanceof File || src instanceof Blob){
    // Preserve File/Blob objects as-is for FormData handling
    target[prefix] = src;
  }else if(src instanceof Date){
    // Convert Date to ISO string
    target[prefix] = src.toISOString();
  }else if(Array.isArray(src)){
    // Handle arrays: if single File/Blob, keep as-is; otherwise recurse
    if(src.length===1 && (src[0] instanceof File || src[0] instanceof Blob)){
      target[prefix] = src[0];
    }else{
      src.forEach((sub: JsonFw|string|File|Blob,key :number)=>{
        flattenobject(prefix===undefined?key.toString():prefix+"."+key,sub,target)
      })
    }
  }else if(typeof src === 'object'){
    Object.entries(src).forEach(([key,sub])=>{
      flattenobject(prefix===undefined?key:prefix+"."+key,sub,target)
    })
  }else{
    target[prefix] = src;
  }
}

fizapilib.setExecutorTs(function(method :string, model :Record<string,Function>,decoder:Function,args :ArrayLike<any>){
  const jsonRequest : {[x:string]:any} = {}
  Object.entries(model).forEach(([key,encoder],index)=>{
    flattenobject(key==='__inline'?undefined:key,encoder(args[index]),jsonRequest)
  })
  return new Promise((resolve,reject)=>{
    add([method,jsonRequest,(response)=>{
      return resolve(decoder(response))
    },reject])
  })
});

export function setUploadProgressBar(progressBar : ProgressBar){
  callContext.uploadProgressBar = progressBar;
}

export default fizapilib.methodsTs;
